import React from "react";
import { RiMoreLine } from "react-icons/ri";
import { dell } from "../../assets/imagesPath";

const QuotationTable = ({ data }) => {
  return (
    <div className="rounded-lg p-4 text-[#030229] py-3 px-6 font-nunito font-bold text-xl leading-none">
      <div className="bg-white shadow-md rounded-lg p-4 text-[#030229] py-3 px-6 font-nunito font-bold text-xl leading-none mb-8">
        <h2 className="font-poppins font-medium text-3xl leading-none text-[#173363] mb-12 pt-8">
          Quotation Table
        </h2>
        <div className="grid grid-cols-6 mb-6">
          <div>ID</div>
          <div>Company Name</div>
          <div>Service</div>
          <div>Trade</div>
          <div>Challenges</div>
          <div>Actions</div>
        </div>
      </div>

      <div className="space-y-6 p-2">
        {data.map((row) => (
          <div
            key={row.id}
            className="bg-white shadow-sm rounded-lg py-5 px-6 grid grid-cols-6 items-center text-sm"
          >
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {row.id}
            </div>
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              <div className="flex items-center space-x-3">
                <img src={dell} alt="dellImage" className="w-8 h-8" />
                <span>{row.company}</span>
              </div>
            </div>
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {row.service}
            </div>
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {row.trade}
            </div>
            <div className="text-[#030229] font-nunito font-normal text-lg leading-none">
              {row.challenges}
            </div>
            <div>
              <button className="text-gray-600 hover:text-gray-900">
                <RiMoreLine className="text-xl" />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuotationTable;
